/**
 * Get the application version
 * Returns the git commit SHA if available, otherwise a fallback
 */
export function getAppVersion(): string {
  try {
    // First try to read from the version.json file generated during build
    const versionData = import.meta.glob('../version.json', { eager: true, import: 'default' }) as Record<string, { commitSha: string }>
    const versionJson = versionData['../version.json']
    if (versionJson?.commitSha && versionJson.commitSha !== 'unknown') {
      return versionJson.commitSha
    }
  } catch {
    // If version.json is not available, continue to next method
  }

  try {
    // Try to access the global constant injected by Vite
    if (typeof __APP_VERSION__ !== 'undefined') {
      return __APP_VERSION__
    }
  } catch {
    // If __APP_VERSION__ is not defined, ignore the error
  }

  // Fallback: use build time or 'dev'
  return 'production'
}

/**
 * Get the build timestamp
 */
export function getBuildTime(): string {
  try {
    if (typeof __BUILD_TIME__ !== 'undefined') {
      return __BUILD_TIME__
    }
  } catch {
    // If __BUILD_TIME__ is not defined, ignore the error
  }

  return new Date().toISOString()
}

// Declare globals to avoid TypeScript errors
declare global {
  const __APP_VERSION__: string
  const __BUILD_TIME__: string
}
